export function getRag(value, ragGreen, ragRed, direction) {
	if (ragGreen == null || ragRed == null) return 'amber';
	if (direction === 'asc') {
		if (value >= ragGreen) return 'green';
		if (value >= ragRed)   return 'amber';
		return 'red';
	} else {
		if (value <= ragGreen) return 'green';
		if (value <= ragRed)   return 'amber';
		return 'red';
	}
}

export const RAG_COLORS = {
	green: { bg: '#E8F5E9', border: '#2E7D32', text: '#1B5E20' },
	amber: { bg: '#FFF8E1', border: '#F57F17', text: '#E65100' },
	red:   { bg: '#FFEBEE', border: '#C62828', text: '#B71C1C' },
};

export const MONTH_LABELS = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export function formatPeriod(year, month) {
	return `${MONTH_LABELS[month]} ${String(year).slice(2)}`;
}

/**
 * Given series data and a viewYear, returns [sliceFrom, sliceTo] indices.
 * null viewYear = show all data.
 */
export function getYearSlice(data, viewYear) {
	if (!viewYear || !data?.length) return [0, data.length - 1];
	const from = data.findIndex(d => d.year === viewYear);
	const last  = [...data].reverse().findIndex(d => d.year === viewYear);
	const to    = last >= 0 ? data.length - 1 - last : -1;
	if (from < 0) return [0, data.length - 1];
	return [from, to];
}